/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsViewListItem,
    ReportingMelcoMachineStatisticsModelsViewListItemFromJSON,
    ReportingMelcoMachineStatisticsModelsViewListItemFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsViewListItemToJSON,
    ReportingMelcoModelsCustomWarning,
    ReportingMelcoModelsCustomWarningFromJSON,
    ReportingMelcoModelsCustomWarningFromJSONTyped,
    ReportingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem
 */
export interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem {
    /**
     * 
     * @type {Array<ReportingMelcoMachineStatisticsModelsViewListItem>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem
     */
    list: Array<ReportingMelcoMachineStatisticsModelsViewListItem>;
    /**
     * 
     * @type {Array<ReportingMelcoModelsCustomWarning>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem
     */
    warning_list?: Array<ReportingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem
     */
    total: number;
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItemFromJSON(json: any): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem {
    return ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItemFromJSONTyped(json, false);
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ReportingMelcoMachineStatisticsModelsViewListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ReportingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItemToJSON(value?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsViewListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ReportingMelcoMachineStatisticsModelsViewListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ReportingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


